var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("RouterLink", { attrs: { to: _vm.conversationLink } }, [
    _c("div", { staticClass: "my-4" }, [
      _c(
        "span",
        {
          staticClass:
            "flex flex-grow-1 cursor-pointer focus:outline-none transition duration-150 ease-in-out w-full mx-auto md:m-0 px-2.5 py-3",
          class: _vm.conversationItemStyle,
          on: { click: _vm.handleConversationClick },
        },
        [
          _c(
            "span",
            {
              staticClass:
                "flex sm:mr-0 sm:mx-auto md:m-0 md:w-full lg:items-start w-full sm:w-14",
            },
            [
              _c(
                "span",
                { staticClass: "block mr-4 sm:mr-5 circleHe" },
                [
                  _c("CircleWithInitials", {
                    attrs: {
                      variant: _vm.TooltipVariants.DARK,
                      title: _vm.conversationName,
                      tooltipClasses: "inboxWidth",
                      avatar: _vm.conversationAvatar,
                      tooltipWidth: 100,
                      primary: "",
                      large: "customChat",
                      cursorPointer: "",
                      showTooltip: "",
                    },
                  }),
                  _vm.isGroupConversation
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "flex items-center justify-center rounded-full text-white relative bottom-4 left-7 newCircle",
                        },
                        [
                          _c("span", { staticClass: "text-sm font-normal" }, [
                            _vm._v(_vm._s(_vm.numberOfParticipants)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "span",
                { staticClass: "flex flex-col overflow-hidden w-full" },
                [
                  _c(
                    "span",
                    { staticClass: "flex justify-between items-baseline" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "block truncate font-bold mr-2 personName",
                          class: _vm.onlyParticipantClass,
                        },
                        [_vm._v(" " + _vm._s(_vm.conversationName) + " ")]
                      ),
                      _c("span", { staticClass: "messageTime" }, [
                        _vm._v(" " + _vm._s(_vm.lastMessageTime) + " "),
                      ]),
                    ]
                  ),
                  _c(
                    "span",
                    { staticClass: "flex justify-between items-baseline" },
                    [
                      _vm.lastMessage
                        ? _c(
                            "span",
                            {
                              staticClass: "w-auto truncate message",
                              class: _vm.isUnRead,
                            },
                            [_vm._v(" " + _vm._s(_vm.lastMessageContent) + " ")]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }